import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useLegendItemStyles = makeStyles((theme: Theme) => ({
  gutters: {
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
}));

const LegendItem = ({
  colour1,
  colour2,
  text,
}: {
  colour1: string;
  colour2: string;
  text: string;
}) => {
  const classes = useLegendItemStyles();
  return (
    <ListItem classes={{ gutters: classes.gutters }}>
      <Box
        display="grid"
        gridTemplateRows="16px"
        gridTemplateColumns="16px 16px 1fr"
        alignItems="center"
      >
        <Box bgcolor={colour1} width="100%" height="100%" />
        <Box bgcolor={colour2} width="100%" height="100%" />
        <Box marginLeft="5px">
          <ListItemText primary={text} />
        </Box>
      </Box>
    </ListItem>
  );
};

interface Props {
  time: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  legend: {
    backgroundColor: theme.palette.background.paper,
    maxWidth: '90px',
  },
}));

export const RainLegend = (props: Props) => {
  const classes = useStyles(props);

  return (
    <Box className={classes.legend}>
      <List dense disablePadding>
        <ListItem>
          <Typography variant="caption" align="center">
            降水量(mm/h)
          </Typography>
        </ListItem>
        <LegendItem colour1="#8ee" colour2="#09c" text="0-10" />
        <LegendItem colour1="#07a" colour2="#058" text="10-20" />
        <LegendItem colour1="#fe0" colour2="#fa0" text="20-30" />
        <LegendItem colour1="#f70" colour2="#f40" text="30-40" />
        <LegendItem colour1="#e00" colour2="#900" text="40+" />
        <LegendItem colour1="#faf" colour2="#f7f" text="雹" />
        <ListItem>
          <Box display="grid" gridAutoFlow="row">
            <Typography variant="caption" align="center">
              更新時間
            </Typography>
            <Typography variant="caption" align="center">
              {props.time}
            </Typography>
          </Box>
        </ListItem>
      </List>
    </Box>
  );
};
